import config from 'config'
import React, { Fragment } from 'react'
import { connect, useSelector } from 'react-redux'
import { withTranslation } from 'react-i18next'
import history, { redirectToPage } from 'srcReact/helpers/history'
import { commonActions } from 'srcReact/components'

const TwoWorkplaceLimit = (props) => {
  const { t, isBillable } = props
  const {
    common: { isNative }
  } = useSelector((state) => state)

  const handlePricingClick = () => {
    redirectToPage('/0/support', isNative)
  }
  const handleClosePopin = () => {
    const { closePopin } = props

    closePopin()
  }

  return (
    <Fragment>
      <h2 className='popin-content--title'>{t('billing.popin.twoWorkplaceLimit.title')}</h2>
      <p className='popin-content--text'>
        {isBillable ? t('billing.popin.twoWorkplaceLimit.ownerText') : t('billing.popin.twoWorkplaceLimit.text')}
      </p>
      <div className='popin-content--image'>
        <img src={`${config.assetUrl}/images/process.svg`} alt='process' />
      </div>
      <div className='popin-content--controllers with-link'>
        {isBillable ? (
          <button type='button' className='button is-primary' onClick={() => handlePricingClick()}>
            {t('billing.popin.twoWorkplaceLimit.ownerBtnText')}
          </button>
        ) : (
          <Fragment>
            <button type='button' className='button is-primary' onClick={() => handleClosePopin()}>
              {t('billing.popin.twoWorkplaceLimit.btnPrimary')}
            </button>
            <a onClick={() => handlePricingClick()} title={t('global.contactUs')} className='controller-link'>
              {t('global.contactUs')}
            </a>
          </Fragment>
        )}
      </div>
    </Fragment>
  )
}

const actionCreators = {
  closePopin: commonActions.closePopin
}

const ExtendedComponent = withTranslation('common')(TwoWorkplaceLimit)
const connectedTwoWorkplaceLimit = connect(null, actionCreators)(ExtendedComponent)

export { connectedTwoWorkplaceLimit as TwoWorkplaceLimit }
